import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { ConfirmationHierarchyMessage } from '../../messages/ConfirmationHierarchyMessage';
import { ConfirmationSummaryMessage } from '../../messages/ConfirmationSummaryMessage';
import { ListSelectMessage } from '../../messages/ListSelectMessage';
import { ListSelectMultiMessage } from '../../messages/ListSelectMultiMessage';
import { NumberedListMessage } from '../../messages/NumberedListMessage/NumberedListMessage';
import { SimpleConfirmationMessage } from '../../messages/SimpleConfirmationMessage';
import styles from './DecisionSlot.module.scss';
import { useSlotPresence } from './useSlotPresence';
const SLOT_CLOSE_MS = 200;
const SLOT_OPEN_MS = 200;
export const GetDecisionSlotTID = (parentTestId)=>getTestIds(parentTestId);
const renderActiveCard = (message, handlers, scrollable)=>{
    const content = message.content;
    switch(content.type){
        case 'simple-confirmation':
            return /*#__PURE__*/ _jsx(SimpleConfirmationMessage, {
                content: content,
                messageId: message.id,
                interactive: true,
                onDismiss: handlers.onDismissProposal,
                onApply: handlers.onApplyProposal,
                frameClassName: styles.slotFrame,
                floating: true,
                scrollable: scrollable
            });
        case 'confirmation-summary':
            return /*#__PURE__*/ _jsx(ConfirmationSummaryMessage, {
                content: content,
                messageId: message.id,
                interactive: true,
                onDismiss: handlers.onDismissProposal,
                onApply: handlers.onApplyProposal,
                frameClassName: styles.slotFrame,
                floating: true,
                scrollable: scrollable
            });
        case 'confirmation-hierarchy':
            return /*#__PURE__*/ _jsx(ConfirmationHierarchyMessage, {
                content: content,
                messageId: message.id,
                interactive: true,
                onDismiss: handlers.onDismissProposal,
                onApply: handlers.onApplyProposal,
                frameClassName: styles.slotFrame,
                floating: true,
                scrollable: scrollable
            });
        case 'list-select':
            return /*#__PURE__*/ _jsx(ListSelectMessage, {
                content: content,
                messageId: message.id,
                onListSelectClick: handlers.onListSelectClick,
                frameClassName: styles.slotFrame,
                floating: true,
                scrollable: scrollable
            });
        case 'list-select-multi':
            return /*#__PURE__*/ _jsx(ListSelectMultiMessage, {
                content: content,
                messageId: message.id,
                interactive: true,
                onDismiss: handlers.onDismissProposal,
                onApply: handlers.onApplyProposal,
                frameClassName: styles.slotFrame,
                floating: true,
                scrollable: scrollable
            });
        case 'numbered-list':
            return /*#__PURE__*/ _jsx(NumberedListMessage, {
                content: content,
                messageId: message.id,
                onOptionClick: handlers.onNumberedListClick,
                frameClassName: styles.slotFrame,
                floating: true,
                scrollable: scrollable
            });
        default:
            return null;
    }
};
export const DecisionSlot = (param)=>{
    let { activeMessage, onDismissProposal, onApplyProposal, onListSelectClick, onNumberedListClick, openMs = SLOT_OPEN_MS, closeMs = SLOT_CLOSE_MS, testId } = param;
    const { DecisionSlotTestIds } = useMemo(()=>GetDecisionSlotTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    const { rendered, open } = useSlotPresence(activeMessage, closeMs);
    const [scrollable, setScrollable] = useState(false);
    useEffect(()=>{
        if (!open) return;
        setScrollable(false);
        const id = setTimeout(()=>setScrollable(true), openMs);
        return ()=>clearTimeout(id);
    }, [
        open,
        openMs
    ]);
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": DecisionSlotTestIds.Root(),
        className: cn(styles.root, {
            [styles.open]: open
        }),
        role: "region",
        "aria-label": t.agenticDrafting.body.decisionSlotLabel(),
        "aria-live": "polite",
        children: rendered != null && renderActiveCard(rendered, {
            onDismissProposal,
            onApplyProposal,
            onListSelectClick,
            onNumberedListClick
        }, scrollable)
    });
};
